import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useProductTitle() {
  const experiment = useExperiments()

  const getScopedTitle = (categoryId: number, title: string) => {
    if (
      experiment['experiment.ppAppleWatchBand'] === 'withoutBand' &&
      categoryId === 170 &&
      title.includes(' - ')
    ) {
      return title.split(' - ').slice(0, -1).join(' - ')
    }

    return title
  }

  return { getScopedTitle }
}
